import { render, staticRenderFns } from "./TableEntrancePopularity.vue?vue&type=template&id=8bb82a1c&scoped=true&"
import script from "./TableEntrancePopularity.vue?vue&type=script&lang=ts&"
export * from "./TableEntrancePopularity.vue?vue&type=script&lang=ts&"
import style0 from "./TableEntrancePopularity.vue?vue&type=style&index=0&id=8bb82a1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bb82a1c",
  null
  
)

component.options.__file = "TableEntrancePopularity.vue"
export default component.exports